import { useState } from "react";

import { Question } from "app/questions/page";
import { HorizontalSeparator } from "ui/HorizontalSeparator";
import { trackEvent } from "utils/analytics/analytics.utils";

import EmptyArrowRight from "./empty-arrow-right.svg";
import FilledArrowDown from "./filled-arrow-down.svg";

export const QuestionDropdown = ({
  analyticsKey,
  answer,
  question,
}: Partial<Question>) => {
  const [isFolded, setIsFolded] = useState(true);

  const toggleFolded = () => {
    if (!isFolded && !!analyticsKey) {
      trackEvent({
        category: "engagement",
        action: "click faq question",
        label: analyticsKey,
      });
    }

    setIsFolded(!isFolded);
  };

  return (
    <div className="px-12 mt-8">
      <details className="mb-8" onToggle={toggleFolded}>
        <summary className="flex gap-x-2 items-center text-lg  font-bold list-none text-left cursor-pointer lg:text-2xl">
          <span>
            {isFolded ? (
              <EmptyArrowRight className="w-[18px]" />
            ) : (
              <FilledArrowDown className="w-[18px]" />
            )}
          </span>
          {question}
        </summary>
        <p className="pl-6 mt-3 lg:text-lg" dangerouslySetInnerHTML={{__html: answer || ''}}></p>
      </details>
      <HorizontalSeparator isBlack />
    </div>
  );
};
